module.exports = __webpack_public_path__ + "static/media/feifengshan_web.79123616.png";